import script from "./NewsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsSection.vue?vue&type=script&setup=true&lang=ts"

import "./NewsSection.vue?vue&type=style&index=0&id=773af192&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773af192"]])

export default __exports__